import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { AnnualReportStep, AutofillOptions } from '@modeso/types__aumico-lib-annualreport-be';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import debug from 'debug';
import fastDeepEqual from 'fast-deep-equal';
import { distinctUntilChanged } from 'rxjs';
import { IFinancialStatementImportOptions } from '../../interfaces/IFinancialStatementImportOptions.interface';
import { ProjectToCopyFrom } from '../../interfaces/project-to-copy-from.interface';

@UntilDestroy()
@Component({
    selector: 'aumico-annualReport-financial-statement-import-options',
    templateUrl: 'financial-statement-import-options.component.html',
    styleUrls: ['financial-statement-import-options.component.scss'],
})
export class FinancialStatementImportOptionsComponent implements OnInit {
    form: UntypedFormGroup;

    @Input() enableOptions = true;
    @Input() activeAnnualReportId: string;
    @Input() uploadAndMappingAutoFillAnnualReportIdExist: string;
    @Input() uploadAndMappingAutoFillAnnualReportToggleDisabled: boolean;
    @Input() userLanguage: string;
    @Input() showAutofillOptions: boolean;
    @Input() activeArNavigation: AnnualReportStep[];
    @Input() autofillOptions: Record<AutofillOptions, string>;

    @Output() importOptions: EventEmitter<IFinancialStatementImportOptions> = new EventEmitter();

    @Output() selectedAnnualReportIdToAutofillFrom = new EventEmitter<Record<AutofillOptions, string>>();

    @Input() projectsList: ProjectToCopyFrom[];
    selectAnnualReportForUploadAndMappingAutoFillToggle: boolean;
    showProjectList: boolean;
    selectedAnnualReportForUploadAndMappingAutoFill: string;
    dialogData: { projects: ProjectToCopyFrom[] };
    private selectedAutofillOptions: AutofillOptions[] = [AutofillOptions.taxonamy];

    constructor(private formBuilder: UntypedFormBuilder) { }

    ngOnInit(): void {
        this.setFormGroup();
        this.monitorChanges();
        this.form
            .get('selectAnnualReportForUploadAndMappingAutoFill')
            .setValue(this.uploadAndMappingAutoFillAnnualReportIdExist);

        if (this.autofillOptions != null) {
            this.selectedAnnualReportForUploadAndMappingAutoFill = this.autofillOptions.taxonamy;

            this.form.get('selectAnnualReportForUploadAndMappingAutoFill').setValue(this.autofillOptions.taxonamy);
        }
    }

    private setFormGroup(): void {
        this.form = this.formBuilder.group({
            importBalanceAndIncomeSeparately: new UntypedFormControl('', []),
            selectAnnualReportForUploadAndMappingAutoFill: new UntypedFormControl('', []),
        });
    }

    private monitorChanges(): void {
        this.form.valueChanges
            .pipe(
                distinctUntilChanged((previousFormChanges, currentFormChanges) =>
                    fastDeepEqual(previousFormChanges, currentFormChanges),
                ),
                untilDestroyed(this),
            )
            .subscribe((value: IFinancialStatementImportOptions) => {
                this.importOptions.emit(value);
                this.selectAnnualReportForUploadAndMappingAutoFillToggle =
                    value.selectAnnualReportForUploadAndMappingAutoFill;
                if (!this.selectAnnualReportForUploadAndMappingAutoFillToggle) {
                    this.selectedAnnualReportIdToAutofillFrom.emit(null);
                }
            });
    }

    onChooseAnnualReportToAutofillFromButtonClicked(): void {
        debug('upload and mapping autofill button is clicked');
        this.dialogData = {
            projects: this.projectsList,
        };

        this.showProjectList = true;
    }

    onRowSelected(annualReportEncryptedId: string): void {
        this.selectedAnnualReportForUploadAndMappingAutoFill = annualReportEncryptedId;
    }

    onSaveSelectedAnnualReportForUploadAndMappingAutoFill(): void {
        const selectedOptions = Object.values(AutofillOptions).reduce((acc, option) => {
            acc[option] = this.selectedAutofillOptions.includes(option)
                ? this.selectedAnnualReportForUploadAndMappingAutoFill
                : null;
            return acc;
        }, {} as Record<AutofillOptions, string>);

        this.selectedAnnualReportIdToAutofillFrom.emit(selectedOptions);
        this.showProjectList = false;
    }

    onSelectedOptionsChange(autofillOptions: AutofillOptions[]): void {
        this.selectedAutofillOptions = autofillOptions;
    }
}
